
        // ✅ Import from firebase-config.js (which uses NPM)
        import { db } from './firebase-config.js';

        import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

        const contactForm = document.getElementById('contactForm');
        const contactSuccess = document.getElementById('contactSuccess');
        const contactBtn = document.getElementById('contactBtn');
        const contactBtnText = document.getElementById('contactBtnText');

        if (contactForm) {
            contactForm.addEventListener('submit', async (e) => {
                e.preventDefault();

                const name = document.getElementById('contactName').value.trim();
                const email = document.getElementById('contactEmail').value.trim();
                const phone = document.getElementById('contactPhone').value.trim();
                const subject = document.getElementById('contactSubject').value;
                const message = document.getElementById('contactMessage').value.trim();

                if (!name || !email || !subject || !message) {
                    alert('Please fill in all required fields.');
                    return;
                }

                // Show loading state
                contactBtn.disabled = true;
                contactBtnText.innerHTML = '<span class="spinner"></span> Sending...';

                try {
                    // Save to Firebase
                    const docRef = await addDoc(collection(db, 'contacts'), {
                        name: name,
                        email: email,
                        phone: phone || '',
                        subject: subject,
                        message: message,
                        status: 'New',
                        createdAt: serverTimestamp()
                    });

                    console.log('✅ Contact message saved with ID:', docRef.id);

                    // Show success
                    contactForm.style.display = 'none';
                    contactSuccess.classList.add('show');
                    contactForm.reset();

                } catch (error) {
                    console.error('❌ Contact form error:', error);
                    alert('There was an error sending your message. Please try again.');
                } finally {
                    contactBtn.disabled = false;
                    contactBtnText.textContent = 'Send Message';
                }
            });
        }

        console.log('📧 IRIE GYM Contact page loaded!');


        /* ============================================================= */
        /* ============================================================= */
        /* =============================================================
                // Using EmailJS
                import emailjs from 'https://cdn.jsdelivr.net/npm/@emailjs/browser@3/dist/emailjs.min.js';
        
                // Initialize
                emailjs.init('YOUR_PUBLIC_KEY');
        
                // Send email after registration
                async function sendConfirmationEmail(name, email, plan) {
                    try {
                        await emailjs.send('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', {
                            to_email: email,
                            to_name: name,
                            plan: plan,
                            gym_name: 'IRIE GYM',
                            gym_address: '123 Irie Lane, Kingston, Jamaica',
                            gym_phone: '+1 (876) 555-1234'
                        });
                        console.log('✅ Confirmation email sent');
                    } catch (error) {
                        console.error('Email error:', error);
                    }
                }*/
    